import React from "react";

const PrimaryBar: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="78"
    height="6"
    viewBox="0 0 78 6"
    fill="none"
    className={className}
  >
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H74.75C76.4069 0 77.75 1.34315 77.75 3C77.75 4.65685 76.4069 6 74.75 6H3C1.34314 6 0 4.65685 0 3Z"
      fill="#FFC600"
    />
  </svg>
);

export default PrimaryBar;
